<div *ngIf="ready"
    [class]="active ? 'overlay clientOverlay clientUserEditOverlay '+currentLang.dir+' active' : 'overlay clientOverlay '+currentLang.dir">
    <div class="ol-main" style="width: 400px;">
        <div class="ol-head grad">
            <div class="ol-close">
                <a style="color: #fff" class="save" (click)="save ();">{{currentLang.words["save"]}}</a>
            </div>
            <div class="ol-title">{{currentLang.words["edit-user"]}}</div>
            <div class="ol-close" (click)="close ();"><span></span></div>
            
        </div>
        <div class="ol-content">
            <div class="full" *ngIf="user">
                <div id="submain">
                    <div class="content">
                        <user-edit [currentLang]="currentLang" [user]="user"></user-edit>
                        <div class="edit edit-button">
                            <div class="edit-param">
                                <button class="big opaque" (click)="save ();">{{currentLang.words["save"]}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ol-right" (click)="close ();"></div>
</div>
